import moment from "moment";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { getWaitingTime } from "../Helper";

import {
  APPOINTMENT_TYPE,
  CONSULTATION_TYPE,
  PAYMENT_METHOD,
  GET_ALL_PROCEDURES_API,
  GET_CLINIC_PROCEDURES_API,
  GET_REFRESHED_DATA_API,
  GET_CLINIC_DOCTOR_LIST_API,
  GET_STAFF_DOCTOR_LIST_API,
} from "./APIConstants";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export const getDashboardppointmentsData = async (payload, api, token) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: token,
    },
  });

  if (res) {
    let modifiedRes = {
      ...res?.data,
      appointments: getModifiedAppointmentsRes(res?.data?.appointments),
    };
    return [modifiedRes, false];
  }
  return [null, true]; // [response, error]
};

export const viewFollowUpDate = async (id) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: `/api/v1/appointments/${id}/followup_reminder`,
    headers: {
      authorization: localStorage.getItem("id_token"),
    },
  });

  if (res?.data?.data) {
    return { res: res?.data?.data[0] };
  }
  return { error: true }; // [response, error]
};

// Helper methods ==>

export const getStatusForParamsFromUrl = (status) => {
  switch (status) {
    case "checked in":
      return "checked_in";
    case "in-clinic":
      return "inclinic";
    case "in progress":
      return "in_progress";
    case "no show":
      return "no_show";
    case "Tele-Consult Regular":
      return "online-regular";
    case "Tele-Consult Follow-Up":
      return "online-followup";
    case "In-Clinic Regular":
      return "inclinic-regular";
    case "In-Clinic Follow-Up":
      return "inclinic-followup";
    default:
      return status;
  }
};

export const getModifiedAppointmentsRes = (data) => {
  let appointments = null;
  if (data?.length > 0) {
    data.map((appnt) => {
      return (
        (appnt.consultation_type = getConsultationType(appnt)),
        (appnt.consultation_type_id = appnt.appointment_consultation_type),
        (appnt.is_follow_up = [1, 6].includes(
          appnt.appointment_consultation_type
        )
          ? "True"
          : "False"),
        (appnt.appointment_type = [0, 1, 2].includes(
          appnt.appointment_consultation_type
        )
          ? APPOINTMENT_TYPE.ONLINE
          : APPOINTMENT_TYPE.IN_CLINIC),
        (appnt.payment_method = getPaymentMethod(appnt)),
        (appnt.slot_duration = getSlotDuration(appnt)),
        (appnt.main_consultation_type = [0, 1].includes(
          appnt.appointment_consultation_type
        )
          ? APPOINTMENT_TYPE.ONLINE
          : [2].includes(appnt.appointment_consultation_type)
          ? APPOINTMENT_TYPE.INSTANT
          : APPOINTMENT_TYPE.IN_CLINIC),
        (appnt.captured_time = getCapturedTime(appnt))
      );
    });
    appointments = data;
  }
  return appointments;
};

export const getConsultationType = (appnt) => {
  let type = "";
  CONSULTATION_TYPE.forEach((ty) => {
    if (appnt.appointment_consultation_type === ty.id) {
      type = ty.value;
    }
  });
  return type;
};

const getPaymentMethod = (appnt) => {
  let method = "";
  if (appnt.appointment_payment_method === PAYMENT_METHOD.ONLINE) {
    method = "Paid Online";
  } else if (
    appnt?.appointment_journey_time?.invoice_raised?.invoice_raised_by !== "" ||
    appnt?.appointment_status.toLowerCase() === "completed"
  ) {
    method = "Paid at Clinic";
  } else {
    method = "Pay at Clinic";
  }
  return method;
};

const getSlotDuration = (appnt) => {
  let start_time = new Date(appnt.appointment_date_and_time);
  let end_time = new Date(
    appnt.appointment_date + " " + appnt.appointment_end_time
  );
  let duration = (end_time - start_time) / 60000;
  let slotDuration = 0;

  if (duration < 0) {
    let startDate = new Date(appnt.appointment_date);
    let AddoneDay = 1;
    let endDate = incrementDate(startDate, AddoneDay);
    let day = ("0" + endDate.getDate()).slice(-2);
    let month = ("0" + (endDate.getMonth() + 1)).slice(-2);
    let year = endDate.getFullYear();
    const nextDate = year + "-" + month + "-" + day;

    let UpdateStart_time = new Date(appnt.appointment_date_and_time);
    let UpdateEnd_time = new Date(nextDate + " " + appnt.appointment_end_time);
    slotDuration = (UpdateEnd_time - UpdateStart_time) / 60000;
  } else {
    slotDuration = duration;
  }

  return slotDuration === 60 ? "1 Hour" : slotDuration + " Mins";
};

function incrementDate(dateInput, increment) {
  let dateFormatTotime = new Date(dateInput);
  return new Date(dateFormatTotime.getTime() + increment * 86400000);
}

const getCapturedTime = (appnt) => {
  let arr = [];
  let captured_time = appnt?.appointment_journey_time;
  if (
    captured_time?.checked_in?.checked_in_time &&
    checkIfGreater(
      captured_time?.checked_in?.checked_in_time,
      captured_time?.no_show?.no_show_time
    ) &&
    !captured_time?.cancelled?.cancelled_time
  ) {
    arr.push(captured_time?.checked_in);
  }

  if (
    captured_time?.checked_in?.checked_in_time &&
    checkIfGreater(
      captured_time?.checked_in?.checked_in_time,
      captured_time?.no_show?.no_show_time
    ) &&
    !captured_time?.cancelled?.cancelled_time
  ) {
    arr.push({ waiting_time: getWaitingTime(captured_time, appnt) });
  }

  if (captured_time?.consultation_started?.consultation_started_time) {
    arr.push(captured_time?.consultation_started);
  }

  if (captured_time?.consultation_ended?.consultation_ended_time) {
    arr.push(captured_time?.consultation_ended);
  }

  if (
    captured_time?.no_show?.no_show_time &&
    checkIfGreater(
      captured_time?.no_show?.no_show_time,
      captured_time?.checked_in?.checked_in_time
    ) &&
    !captured_time?.cancelled?.cancelled_time
  ) {
    arr.push(captured_time?.no_show);
  }

  if (captured_time?.cancelled?.cancelled_time) {
    arr.push(captured_time?.cancelled);
  }

  return arr;
};

const checkIfGreater = (time1, time2) => {
  let greater = false;
  if (time1 && time2) {
    if (moment(time1) > moment(time2)) {
      greater = true;
    }
  } else {
    greater = true;
  }
  return greater;
};

// <===

export const getMenuItems = async (payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: GET_CLINIC_PROCEDURES_API,
    data: payload,
    headers: {
      authorization: localStorage.getItem("id_token"),
    },
  });

  if (res) {
    return [res.data, false];
  }
  return [null, true]; // [response, error]
};

export const getProcedureForConsultationFilter = async (payload, token) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: GET_ALL_PROCEDURES_API,
    data: payload,
    headers: {
      authorization: token,
    },
  });
  let modifiedResponse = [];
  if (res?.data?.procedures?.length > 0) {
    res.data.procedures.forEach((data) => {
      let procedure = modifiedResponse.find((ele) => ele.value === data);
      if (!procedure?.value) {
        let obj = {};
        obj["name"] = data;
        obj["value"] = data;
        obj["type"] = "procedure";
        obj["selected"] = false;
        modifiedResponse.push(obj);
      }
    });
  }
  if (res?.data?.tests?.length > 0) {
    res.data.tests.forEach((data) => {
      let procedure = modifiedResponse.find((ele) => ele.value === data);
      if (!procedure?.value) {
        let obj = {};
        obj["name"] = data;
        obj["value"] = data;
        obj["type"] = "procedure";
        obj["selected"] = false;
        modifiedResponse.push(obj);
      }
    });
  }
  modifiedResponse &&
    modifiedResponse.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  return [modifiedResponse, false];
};

export const getRefreshedAppointmentData = async (payload, logger, token) => {
  try {
    const res = await afterLoginApiAxios({
      method: "post",
      url: GET_REFRESHED_DATA_API,
      data: payload,
      headers: {
        authorization: token ?? localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
      },
    });

    if (res) {
      let modifiedRes = {
        ...res?.data,
        appointments: getModifiedAppointmentsRes(res?.data?.appointments),
      };
      return [modifiedRes, false];
    }
    return [null, true]; // [response, error]
  } catch (error) {
    logger.error("Error in refresh api :" + JSON.stringify(error));
    return [null, error];
  }
};

export const getStaffDoctorList = async (payload, token) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: GET_STAFF_DOCTOR_LIST_API,
    data: payload,
    headers: {
      authorization: token,
    },
  });

  if (res) {
    if (
      res?.data?.all_related_doctors &&
      res.data.all_related_doctors.length > 0
    ) {
      res.data.all_related_doctors.map(
        (data, indx) => (
          (res.data.all_related_doctors[indx].id = data.doctor_id),
          (res.data.all_related_doctors[indx].selected_doctor = false),
          (res.data.all_related_doctors[indx].label = data.dr_name),
          (res.data.all_related_doctors[indx].value = data.dr_first_name),
          (res.data.all_related_doctors[indx].name = data.dr_name),
          (res.data.all_related_doctors[indx].initials =
            data.dr_first_name.charAt(0)),
          (res.data.all_related_doctors[indx].selected = false),
          (res.data.all_related_doctors[indx].doctor_first_name =
            data.dr_first_name),
          (res.data.all_related_doctors[indx].doctor_last_name =
            data?.dr_middle_name + " " + data?.dr_last_name),
          (res.data.all_related_doctors[indx].doctor_profile_picture_url =
            data?.profile_picture_url ? [data?.profile_picture_url] : []),
          (res.data.all_related_doctors[indx].doctor_phone_no =
            data.dr_phone_no),
          (res.data.all_related_doctors[indx].doctor_name = data.dr_name)
        )
      );
      return [res.data.all_related_doctors, false];
    }
  }
  return [[], true]; // [response, error]
};

export const getClinicDoctorList = async (params, token) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: GET_CLINIC_DOCTOR_LIST_API,
    params: params,
    headers: {
      authorization: token,
    },
  });

  if (res) {
    if (res?.data?.doctor_list && res.data.doctor_list.length > 0) {
      res.data.doctor_list.map(
        (data, indx) => (
          (res.data.doctor_list[indx].id = data.doctor_id),
          (res.data.doctor_list[indx].selected_doctor = false),
          (res.data.doctor_list[indx].label = data.doctor_name),
          (res.data.doctor_list[indx].value = data.doctor_first_name),
          (res.data.doctor_list[indx].name = data.doctor_name),
          (res.data.doctor_list[indx].initials =
            data.doctor_first_name.charAt(0))
        )
      );
      return [res.data.doctor_list, false];
    }
  }
  return [[], true]; // [res, error]
};
